import axios from "axios";

export const pluginService = {
  async getMKBQueryStats(params = {}) {
    try {

      const response = await axios.get("/api-plug/mkb-query-stats/", {
        params: {
          created_at_from: params.from || "2026-01-01",
          created_at_to: params.to || new Date().toISOString().split('T')[0],
        }
      });
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error("Ошибка API:", error);
      return [];
    }
  }
};